// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"InputCheckbox_CheckBox__3ALVG","CheckedCheckBox":"InputCheckbox_CheckedCheckBox__3UFBW","CheckBoxText":"InputCheckbox_CheckBoxText__21XcE"};